import Marionette from "backbone.marionette";
import templates from "../../utils/templates";
import _ from "underscore";

const DEFAULTS = {
  className: "alert",
  attributes: {
    role: "alert",
  },
  template: templates.find("generic", "alert"),
};

class View extends Marionette.ItemView {
  constructor(options = {}) {
    _.defaults(options, DEFAULTS);
    super(options);
  }

  events() {
    return {
      // handle close behavior here, do not use data-dismiss="alert"
      "click button.close": "_dismiss",
    };
  }

  onBeforeRender() {
    this.$el.addClass(`alert-${this.model.getType()}`);

    if (!this.model.getAutoDismiss()) {
      this.$el.addClass("alert-dismissable");
    }
  }

  onShow() {
    if (this.model.getAutoDismiss()) {
      // automatically dismiss after timeout
      this._show(this.model.getAutoDismissTimeout());
    } else {
      // let user dismiss

      this._show();
    }
  }

  _dismiss() {
    this._hideAfterFn(250);
  }

  _show(timeout) {
    let cb = null;
    if (_.isNumber(timeout) && timeout > 0) {
      cb = this._hideAfterFn(timeout);
    }

    // make it visible
    this.$el.parent().addClass("active", cb);
  }

  _hide(cb) {
    // make sure callback is a function
    cb = _.isFunction(cb) ? cb : null;

    // make it invisible
    this.$el.parent().removeClass("active", cb);
  }

  _hideAfterFn(timeout) {
    _.delay(() => {
      this._hide();
    }, timeout);
  }
}

export { View as default };
